// Which face the panel shows when it opens on a brand's shop.
//
// Two mistakes are possible and both were made.
//
// Opening on the greeting every time: a customer asks something in the card at
// the foot of the page, opens the panel, and finds a front door where their
// question should be. That is what made the panel feel like a second, separate
// product rather than the same conversation.
//
// Opening on the conversation every time: the fix for the first, and worse. It
// threw away the brand's own front door — the greeting, the suggested
// questions, the menu, and the line offering to sign in, which is the only way
// into an account from a shop. Embedded panels had no way to sign in at all.
//
// So: the conversation once there is one, the front door until then.
//
// That middle course did not hold either (owner, 2026-10-17). A shopper who
// opened the column before asking anything met a dark front door with tabs,
// in a different design from the conversation, beside a card already talking
// about a dress: two products again. The reference opens its column straight
// into the conversation, the welcome line and the brand's questions inside
// it. So do we now, and what was lost the first time is carried into the
// conversation instead: the offer to sign in is in its opening line, and the
// back control still reaches the front door and the menus.
//
// Unless the visitor has asked for the front door. "Once there is a
// conversation" is about which face the panel OPENS on, and it was also
// deciding where the visitor was allowed to go: the conversation screen's back
// control returned here, this rule sent them straight back, and the button did
// nothing. The front door is the only route to the menus, and through them to
// the account and the only way to sign out, so a visitor who has ever asked a
// question could not reach their account again. Asking for it is not the same
// as arriving.

/**
 * @param {object} state
 * @param {boolean} state.leanChrome       embedded on a brand's shop
 * @param {boolean} state.frontDoorAsked   the visitor asked to go back to it
 * @returns {boolean} true to open on the conversation, false for the front door
 */
export function opensOnConversation(state) {
  if (!state || !state.leanChrome) return false;
  return !state.frontDoorAsked;
}

// The front door's own half of the same rule. When the shop really navigates,
// the panel is rebuilt on the front door, and the front door sends the visitor
// back into the conversation they were having — once per page load. It also
// did that to a visitor who had just pressed the conversation's back control
// to get here, so the button bounced straight back and the menus, and the way
// to sign in, were out of reach again.

/**
 * @param {object} state
 * @param {number}  state.messageCount     messages already exchanged
 * @param {boolean} state.alreadyResumed   this page load has resumed once
 * @param {boolean} state.frontDoorAsked   the visitor asked to come here
 * @returns {boolean} true to move on to the conversation
 */
export function resumesConversation(state) {
  if (!state || !state.messageCount) return false;
  if (state.alreadyResumed || state.frontDoorAsked) return false;
  return true;
}

export default opensOnConversation;
